import { getRenderDataSource } from "../../../store/common/action";

/**
 * @fileOverview 获取当前行数据 由前一个函数传入组件结构
 */
export const getRowData = async (func, customParamsList, customFunctionParams, instanceId) => {
  console.log("getRowData", { func, customParamsList, customFunctionParams });
  let component = {} as ComponentItem;
  let renderData = getRenderDataSource(instanceId, component.dataSource);
  return _get(renderData, component.index);
}

